export default __webpack_public_path__ + "static/media/bannerBgMb.1504ed82.png";